import React, { Component } from "react";
import Appbar from "./appbar";
import DemoCarousel from "../auth/carsouel";
import Footer from "./footer";


export default class CommonTemplate extends Component {
  render() {
    const { title, textOne, textTwo, count } = this.props;
    return (
      <div className="login-container">
        <Appbar />
        <div className="login-without-appbar">
          <DemoCarousel />
          <div className="login-right-div" style={{ overflowY: "scroll" }}>
            <div className="login-title">{title}</div>
            {count === 2 ? <div className="otp-text">{textOne}</div> :  <div className="otp-text">{textTwo}</div>}
            {this.props.children}
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
